import { object, string } from 'zod';

import { makeZodValidate } from '@occc-app/design-system';
import { IS_REQUIRED } from '@occc-app/lib/constants/validationMessages';

export const campaignSchema = object({
  name: string({ required_error: IS_REQUIRED }).trim().min(1),
});

export const validateCampaign = makeZodValidate(campaignSchema);
